import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=07b28d9b&scoped=true&"
import script from "./OfferDetails.vue?vue&type=script&lang=ts&"
export * from "./OfferDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OfferDetails.vue?vue&type=style&index=0&id=07b28d9b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b28d9b",
  null
  
)

export default component.exports